import { CarlinkSticker } from "./CarlinkSticker";

export const WindshieldScene = ({ src, alt, stickerClass, size = "sm", testId, children, className = "" }) => (
  <div data-testid={testId} className={`relative overflow-hidden rounded-2xl border border-white/10 bg-[#0F111A] ${className}`}>
    <img src={src} alt={alt} className="h-full w-full object-cover" loading="eager" decoding="async" />
    <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#07080C]/70 via-transparent to-transparent" />
    <div className={`absolute ${stickerClass}`}>
      <div className="sticker-on-glass">
        <CarlinkSticker size={size} />
      </div>
    </div>
    {children}
  </div>
);
